export const placesBoende = [
  'Inomhus - Kök',
  'Inomhus - Vardagsrum',
  'Inomhus - Samtalsrum',
  'Inomhus - Ungdomens rum',
  'Inomhus - Kontor',
  'Inomhus - Aktivitetsrum',
  'Inomhus - Skola',
  'Inomhus - Idrottsplats (gym, badhus)',
  'Inomhus - Affär/frisör',
  'Inomhus - Myndighet',
  'Inomhus - Ungdomens hembostad',
  'Inomhus - Hemma',
  'Inomhus - Plats för nöjen (t ex bio, kafé)',
  'Inomhus - Annat',
  'Utomhus - Trädgård',
  'Utomhus - Idrottsplats',
  'Utomhus - Natur',
  'Utomhus - Bad',
  'Utomhus - Stad/samhälle',
  'Utomhus - Bil eller annat transportmedel',
  'Utomhus - Annat',
];
